import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding__wrapper" }
const _hoisted_2 = { class: "button-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OButton = _resolveComponent("OButton")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('onboarding.none.description')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_OButton, {
        variant: "primary",
        rounded: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.disableMFA()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('onboarding.none.finish')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}